import axios from "../config/axios"

const API_BASE = "/ml-sheets"

const buildListParams = (page, perPage, filters = {}) => {
  const params = {
    ...(page && { page }),
    ...(perPage && { per_page: perPage }),
  }

  if (filters.search?.trim()) {
    params.search = filters.search.trim()
  }

  if (filters.status) params.status = filters.status
  if (filters.from_date) params.from_date = filters.from_date
  if (filters.to_date) params.to_date = filters.to_date

  const fromIds = filters.from_location_ids
  if (Array.isArray(fromIds) && fromIds.length > 0) {
    params.from_location_ids = fromIds.join(",")
  } else if (typeof fromIds === "string" && fromIds) {
    params.from_location_ids = fromIds
  }

  const toIds = filters.to_location_ids
  if (Array.isArray(toIds) && toIds.length > 0) {
    params.to_location_ids = toIds.join(",")
  } else if (typeof toIds === "string" && toIds) {
    params.to_location_ids = toIds
  }

  const senderNames = filters.sender_locations
  if (Array.isArray(senderNames) && senderNames.length > 0) {
    params.sender_location = senderNames.join(",")
  }

  const receiverNames = filters.receiver_locations
  if (Array.isArray(receiverNames) && receiverNames.length > 0) {
    params.receiver_location = receiverNames.join(",")
  }

  return params
}

export const mlSheetService = {
  // Get all ML Sheets with filters and pagination
  getAllMLSheets: (page = null, perPage = null, filters = {}) => {
    return axios.get(API_BASE, { params: buildListParams(page, perPage, filters) })
  },

  // Get single ML Sheet
  getMLSheet: (mlSheetId) => {
    return axios.get(`${API_BASE}/${encodeURIComponent(mlSheetId)}`)
  },

  // Create ML Sheet
  createMLSheet: (data) => {
    return axios.post(API_BASE, data)
  },

  // Update ML Sheet
  updateMLSheet: (mlSheetId, data) => {
    return axios.put(`${API_BASE}/${mlSheetId}`, data)
  },

  // Update ML Sheet status only (required for Agent role)
  updateMLSheetStatus: (mlSheetId, status) => {
    return axios.put(`${API_BASE}/${encodeURIComponent(mlSheetId)}`, { status })
  },

  // Delete ML Sheet
  deleteMLSheet: (mlSheetId) => {
    return axios.delete(`${API_BASE}/${mlSheetId}`)
  },

  // Get booked shipments by location and date - NEW DYNAMIC SEARCH
  getBookedShipments: (params = {}) => {
    return axios.get(`${API_BASE}/booked-shipments`, { params })
  },

  // Generate PDF
  generatePDF: (mlSheetId) => {
    return axios.get(`${API_BASE}/${mlSheetId}/pdf`, {
      responseType: "blob",
    })
  },

  // Download PDF
  downloadPDF: (mlSheetId) => {
    return axios.get(`${API_BASE}/${mlSheetId}/pdf/download`, {
      responseType: "blob",
    })
  },

  // Get all agents for access field
  getAgents: () => {
    return axios.get("/users", { params: { role_id: 3, all: true } })
  },

  // Get shipment by ID
  getShipmentById: (shipmentId) => {
    return axios.get(`/shipments/${shipmentId}`)
  },

  // Get all locations
  getLocations: () => {
    return axios.get("/location-hubs", { params: { all: true } })
  },

  // Get all vehicles without pagination
  getAllVehiclesNoPage: () => {
    return axios.get("/vehicles", { params: { all: true } })
  },
}